import React from 'react';
import { IconPlayerPlay } from '@tabler/icons-react';

const VideosSection = () => {
  return (
    <section className="ub-videos-section">
      <div className="ub-videos-placeholder">
        <IconPlayerPlay size={64} color="#00d4ff" strokeWidth={1.5} />
        <p className="ub-placeholder-text">Video content coming soon</p>
      </div>
    </section>
  );
};

export default VideosSection;
